import { useMemo } from 'react';

import { VPPProgramOffer, VPPProgramStatus } from 'clipsal-cortex-types/src/api/api-saturn-vpp';

import { useGetVppProgramOffers } from './vppApi';

export function getProgramOfferByStatus(programOffers: VPPProgramOffer[], status: VPPProgramStatus) {
  return programOffers.find(({ equipment_programs: equipmentPrograms }) =>
    equipmentPrograms?.find(({ status: programStatus }) => programStatus == status)
  );
}

export function useGetProgramOffersByStatus(inverterId: number, status: VPPProgramStatus) {
  const { programOffers, isLoading: isProgramOffersLoading, isError } = useGetVppProgramOffers(inverterId);
  const isLoaded = !isProgramOffersLoading;
  const programOffersByStatus = useMemo(() => {
    if (isLoaded && !isError) {
      return programOffers.filter(({ equipment_programs: equipmentPrograms }) =>
        equipmentPrograms?.find(({ status: programStatus }) => programStatus == status)
      );
    }
    return [];
  }, [isLoaded, isError, programOffers, status]);

  return {
    programOffers: programOffersByStatus,
    isLoaded,
    isError,
  };
}
